import { jsx as t } from "react/jsx-runtime";
import { forwardRef as m } from "react";
import { faSpinnerThird as a } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon as n } from "@fortawesome/react-fontawesome";
import { twMerge as f } from "tailwind-merge";
const x = m(
  ({ variant: e = "absolute", size: r = "xl", className: o, ...i }, s) => /* @__PURE__ */ t(
    "div",
    {
      ref: s,
      className: f(
        e === "absolute" && "absolute inset-0",
        e === "static" && "static",
        "flex items-center justify-center text-gray-500",
        o
      ),
      ...i,
      children: /* @__PURE__ */ t(n, { size: r, className: "animate-spin", icon: a })
    }
  )
);
export {
  x as Loader
};
